import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default React.memo(props => (
  <SvgIcon {...props} width="17" height="20" viewBox="0 0 17 20" fill="none">
    <path
      d="M13.214 5.354L11.254 15H9.546L7.768 6.922L5.976 15H4.31L2.35 5.354H3.652L5.206 13.838L7.068 5.354H8.482L10.386 13.838L11.996 5.354H13.214Z"
      fill="currentColor"
    />
  </SvgIcon>
));
